import { computed, defineComponent } from 'vue';
import IncompleteKYC from '@/components/kyc/IncompleteKyc.vue';
import PersonalDetails from '@/components/kyc/PersonalDetails.vue';
import ResidentialDetails from '@/components/kyc/ResidentialDetails.vue';
import SourceOfFunds from '@/components/kyc/SourceOfFunds.vue';
import IDDetails1 from '@/components/kyc/IDDetails1.vue';
import SelectIdCard from '@/components/kyc/SelectIdCard.vue';
import IDDetails2 from '@/components/kyc/IDDetails2.vue';
import SubmitDocs from '@/components/kyc/SubmitDocs.vue';
import IdDuplication from '@/components/kyc/IdDuplication.vue';
import VerificationStatus from '@/components/kyc/VerificationStatus.vue';
import BlockedStatus from '@/components/kyc/BlockedStatus.vue';
import CompleteStatus from '@/components/kyc/CompleteStatus.vue';
import { KycTypes } from '@/types/kyc';
import { useKycStore } from '@/store/modules/kyc';
import { storeToRefs } from 'pinia';
var KycSteps = KycTypes.KycSteps;
export default defineComponent({
    name: 'KycView',
    props: {},
    components: {
        IncompleteKYC,
        PersonalDetails,
        ResidentialDetails,
        IDDetails1,
        SelectIdCard,
        IDDetails2,
        SubmitDocs,
        IdDuplication,
    },
    setup() {
        // user will be directed here after login, the kyc status on the userObject will determine what gets displayed
        const kycStore = useKycStore();
        const { currentStep } = storeToRefs(kycStore);
        const stepsList = [
            {
                name: KycTypes.KycSteps.KYC_1,
                component: IncompleteKYC,
            },
            {
                name: KycTypes.KycSteps.KYC_2,
                component: PersonalDetails,
            },
            {
                name: KycSteps.KYC_3,
                component: ResidentialDetails,
            },
            {
                name: KycSteps.KYC_4,
                component: SourceOfFunds,
            },
            {
                name: KycSteps.KYC_5,
                component: IDDetails1,
            },
            {
                name: KycSteps.KYC_6,
                component: SelectIdCard,
            },
            {
                name: KycSteps.KYC_7,
                component: IDDetails2,
            },
            {
                name: KycSteps.KYC_8,
                component: SubmitDocs,
            },
            {
                name: KycSteps.ID_DUPLICATE,
                component: IdDuplication,
            },
            {
                name: KycSteps.VERIFICATION_STATUS,
                component: VerificationStatus,
            },
            {
                name: KycSteps.BLOCKED,
                component: BlockedStatus,
            },
            {
                name: KycSteps.COMPLETE,
                component: CompleteStatus,
            },
        ];
        const activeTab = computed(() => stepsList.find(item => item.name === currentStep.value).component);
        return {
            currentStep,
            stepsList,
            activeTab,
        };
    },
});
